export const getPagination = ({ pagination }) => pagination;
export const contrapartida_modelo_empty = () => ({
  tipo_contrapartida: "",
  descricao: "",
  maxima: 0,
  minima: 0,
  unidade: "R$"
});
export const tipos_contrapartida = () => [
  {
    value: "financeira",
    text: "Financeira"
  },
  {
    value: "bens-servico",
    text: "Bens de Serviço"
  },
  {
    value: "negociavel",
    text: "Negociável"
  }
];

export const unidades = () => [
  {
    value: "R$",
    text: "Moeda (R$)"
  },
  {
    value: "%",
    text: "Porcentagem (%)"
  }
];
